import {SensorsiteModel} from './sensorsite.model';

export class SensorModel {

  public hardwareName: string;
  public serverName: string = '';
  public regionName: string = '';

  private _lastTimeSeen: string;

  constructor(
    public id: number = 0,
    public sensorId: number = 0,
    public description: string = '',
    public hardwareTypeId: number = 0,
    public hardwareType: string = '',
    public serverId: number = 0,
    public macEth: number = 0,
    public macWlan: string = '',
    public initialized: boolean = false,
    public monitoringLagMinutes: number = 0,
    public status: string = 'offline',
    public softwareVersion: string = '',
    public location: string = '',
    public region: number = -1,
    public lastTimeSeen: string= '',
    public sites: SensorsiteModel[] = [],
  ) {
    this._lastTimeSeen = lastTimeSeen;
  }

  get dateLastTimeSeen(): Date {
    return new Date(this._lastTimeSeen);
  }

  set dateLastTimeSeen(value: Date) {
    this._lastTimeSeen = String(value);
  }

  get initializedStatus(): String {
    return this.initialized ? 'initialised' : 'not initialised';
  }
}

// {
//   "id": 2,
//   "description": "located at Singapore Office(old ID: 571)",
//   "hardwareTypeId": 1,
//   "macEth": null,
//   "macWlan": null,
//   "serverId": 6,
//   "initialized": false,
//   "monitoringLagMinutes": 10,
//   "status": "offline",
//   "softwareVersion": "4.2",
//   "location": "In storage",
//   "region": null,
//   "lastTimeSeen": "2016-07-15T02:40:20"
// }
